import api from './api';

export const trainingAPI = {
  // Streams
  listStreams:    ()           => api.get('/training/streams.php'),
  saveStream:     (data)       => api.post('/training/streams.php', data),
  deleteStream:   (id)         => api.post('/training/delete_stream.php', { id }),
  streamEmployees:(streamId)   => api.get('/training/stream_employees.php', { params: { stream_id: streamId } }),

  // Employee training record
  getEmployee:   (employeeId)  => api.get('/training/employee.php', { params: { employee_id: employeeId } }),
  assign:        (data)        => api.post('/training/assign.php', data),

  // All employees (with optional training data)
  allEmployees:  ()            => api.get('/training/all_employees.php'),

  // Projects
  saveProject:   (data)        => api.post('/training/save_project.php', data),
  deleteProject: (id)          => api.post('/training/delete_project.php', { id }),
};
